import { Component, inject, input } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faArrowLeftLong, faArrowRightLong } from "@fortawesome/free-solid-svg-icons";
import { TranslatePipe } from "@ngx-translate/core";

import { LanguageService } from "../../../services";

@Component({
  selector: "adaa-item-slider",
  imports: [FontAwesomeModule, TranslatePipe],
  templateUrl: "./item-slider.html",
  styleUrl: "./item-slider.scss",
  host: {
    "[class.has-header-controls]": "arrowsInHeader()",
  },
})
export class ItemSliderComponent {
  readonly languageService = inject(LanguageService);

  hasTitle = input<boolean>(true);
  showPerformance = input<boolean>(false);
  scrollInput = input<number>(400);
  arrowsInHeader = input<boolean>(false);

  readonly leftArrow = faArrowLeftLong;
  readonly rightArrow = faArrowRightLong;

  public get backwards(): "left" | "right" {
    return this.languageService.direction() === "ltr" ? "left" : "right";
  }

  public get forwards(): "left" | "right" {
    return this.languageService.direction() === "ltr" ? "right" : "left";
  }

  public onClick(container: HTMLDivElement, dir: "left" | "right") {
    container.scrollBy({
      top: 0,
      left: dir === "right" ? this.scrollInput() : -this.scrollInput(),
      behavior: "smooth",
    });
  }
}
